export type FaveProps = number;

export type FavesProps = FaveProps[];

const faves: FavesProps = [2861, 2243, 2578, 1765, 1925, 2896, 2840];

export default faves;



// WEBPACK FOOTER //
// ./src/data/faves.tsx